import contactsTemplate from './contacts.html';

export default angular
  .module('main.organizations.edit.tabs.contacts', [])

  .directive('editOrganizationContactsTab', () => {
    return {
      restrict: 'E',
      template: contactsTemplate,
      scope: {},
      controller: ($scope,
                   $rootScope,
                   $q,
                   $filter,
                   utils,
                   ToastsService,
                   EditOrganizationDataProvider) => {
        const $t = $filter('translate');

        const ORGANIZATION_CONTACTS = [
          'contactName1',
          'contactEmail1',
          'contactPhone1',
          'officePhone',
        ];
        const ORGANIZATION_PROPERTIES = [
          'businessName',
          'businessUrl',
          'billingUrl',
        ];

        $scope.dataProvider = EditOrganizationDataProvider.instance;

        // #region Form Controls

        $.fn.form.settings.rules.contactEmail = function(value) {
          if (!value) {
            return true;
          }
          return $.fn.form.settings.rules.email(value);
        };

        $('#form-contacts').form({
          inline: true,
          keyboardShortcuts: false,
          fields: {
            email: {
              rules: [
                {
                  type: 'contactEmail',
                  prompt: $t('prompt.orgs.email')
                }
              ]
            },
            email2: {
              rules: [
                {
                  type: 'contactEmail',
                  prompt: $t('prompt.orgs.email')
                }
              ]
            }
          }
        });

        // #endregion

        angular.extend($scope, {
          helpers: {}, // form fields
          onCancelButtonClick: $scope.dataProvider.goBack,
          copyToClipboard: $rootScope.copyToClipboard,
          canSaveContacts: canSaveContacts,
          saveContacts: saveContacts,
        });

        init();

        function init() {
          $scope.loading = true;

          $q.all([
            $scope.dataProvider.organizationResource.init(),
            $scope.dataProvider.organizationPropsResource.init(),
          ])
            .then(() => {
              initOrganizationContactsModel();
              $scope.loading = false;
            }, () => {
              $scope.loading = false;
            });
        }

        function initOrganizationContactsModel() {
          $scope.organization = angular.copy($scope.dataProvider.organizationResource.value);
          $scope.properties = angular.copy($scope.dataProvider.organizationPropsResource.value || []);
          initOrgProperties();
        }

        function initOrgProperties() {
          ORGANIZATION_PROPERTIES.forEach(propName => {
            $scope.helpers[propName] = getPropertyByName(propName);
          });
        }

        function getPropertyByName(name) {
          return utils.getPropertyByName($scope.properties, name, true);
        }

        function canSaveContacts() {
          let contacts = {};
          ORGANIZATION_CONTACTS.forEach(fieldName => contacts[fieldName] = $scope.organization[fieldName]);
          let propsChanged = ORGANIZATION_PROPERTIES.some(el => {
            let property = $scope.properties.find(p => p.name === el);
            return property ? property.value !== $scope.helpers[el] : !!$scope.helpers[el];
          });
          return !utils.compareFormObjects(contacts, $scope.dataProvider.organizationResource.value, Object.keys(contacts)) || propsChanged;
        }

        function saveContacts() {
          $scope.loading = true;

          $('#form-contacts').form('validate form');
          if (!$('#form-contacts').form('is valid')) {
            $scope.loading = false;
            return false;
          }

          let orgInfo = {};
          let orgProps = [];
          ORGANIZATION_CONTACTS.forEach(fieldName => orgInfo[fieldName] = $scope.organization[fieldName]);
          ORGANIZATION_PROPERTIES.forEach(propName => {
            orgProps.push({
              name: propName,
              value: $scope.helpers[propName] || ''
            });
          });

          return $q.all([
            $scope.dataProvider.saveOrganizationInfo(orgInfo),
            $scope.dataProvider.saveOrganizationProps(orgProps)
          ])
          .then(() => {
            ToastsService.success();
            initOrganizationContactsModel();
            $scope.loading = false;
          }, (err) => {
            $scope.loading = false;
            ToastsService.error(err);
          });
        }

      }
    };
  })
  .name;
